var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CharacteristicEdit", {
    attrs: {
      value: _vm.value,
      "characteristic-items": _vm.meta.functionMarketingRole,
      "characteristic-type": _vm.meta.functionMarketingRoleType,
      title: "Marketingtätigkeiten (Vorerfahrung)",
      "supplements-config": {
        disable: true
      },
      "nothing-allowed": {
        onlyOverall: true,
        overall: {
          text: "Es ist keine Vorerfahrung nötig"
        }
      },
      "experience-config": {
        noneAllowed: false
      },
      selectedItemsConfig: {
        labelType: _vm.labelTypeJobProfile
      },
      "additions-config": {
        type: "customer"
      },
      "label-set": "customer",
      "label-type": _vm.labelTypeJobProfile,
      "open-fan-label": "Hinzufügen",
      "open-fan-label-with-selection": "Bearbeiten",
      "open-fan-button-alignment": "left"
    },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }